module.exports = __webpack_public_path__ + "img/redEnvelopedRainUnconcernedBackground.b6860f87.png";